import React from "react";
import PropTypes from "prop-types";

import { Input, Field, Control, Label } from "rbx";
import { LocationSelect } from "../inputs";

function RouteFilters({ filters, onChange }) {
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...filters };
    if (e.target.name.includes("RecIdRef")) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    onChange(
      Object.keys(updates).reduce((a, c) => {
        if (String(updates[c]).length) {
          a[c] = updates[c];
        }
        return a;
      }, {})
    );
  };

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <Label>Route Id</Label>
          <Input
            autocomplete="new"
            name="RouteId_contains"
            type="text"
            value={filters.RouteId_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Delivery City</Label>
          <Input
            autoComplete="new"
            name="DeliveryLocationCity_contains"
            type="text"
            value={filters.DeliveryLocationCity_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <LocationSelect
            label="Delivery Location"
            name="DeliveryLocationRecIdRef"
            showHelp={false}
            value={filters.DeliveryLocationRecIdRef}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}
RouteFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func
};
export default RouteFilters;
